export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapGateControllers';
export const ENTITY_EDIT_ROUTE = 'gates/systems/view';
